import * as React from "react";
import { SVGProps } from "react";

const MODO_LOGO_PATHS = (
  <g>
    <path fill="#fff" d="M43.44,35.86c.52.26,1.08.39,1.68.41,3.21.11,5.45-3.19,4.03-6.11-.55-1.13-1.44-1.88-2.68-2.27-.41-.13-.87-.16-1.32-.19-1.7-.12-1.59-2.7.07-2.75.55-.02,1.13.05,1.72.19,4.1,1,6.42,5.3,4.98,9.27-1.66,4.56-7.33,6.07-11.08,3.05-1.74-1.4-2.71-3.58-2.6-5.81.09-1.68.72-3.18,1.91-4.5.33-.37.73-.55,1.2-.54.66.01,1.21.56,1.29,1.2.06.49-.08.81-.44,1.2-1.99,2.16-1.42,5.54,1.24,6.83Z" />
    <path fill="#fff" d="M79.18,34.32c1.76-2.8-.09-6.31-3.31-6.59-.48-.04-.77-.08-.88-.13-1.08-.44-1.05-2.12.03-2.54.21-.08.5-.11.87-.1,3.59.17,6.46,2.98,6.71,6.54.33,4.66-3.83,8.28-8.39,7.4-2.71-.52-4.87-2.59-5.51-5.28-.55-2.29.09-4.8,1.78-6.52,1.4-1.42,3.37.47,1.94,2-1.64,1.76-1.5,4.6.37,6.15,1.95,1.61,5,1.26,6.38-.95Z" />
    <path fill="#fff" d="M33.26,30.89s-.01-.03-.03-.03c0,0-.02,0-.02.01-1.11,1.55-2.23,3.11-3.34,4.66-.31.43-.73.63-1.25.6-.45-.03-.81-.23-1.09-.61-1.89-2.67-3.8-5.33-5.7-7.98-.24-.33-.38-.6-.42-.8-.23-1.13,1.07-2.08,2.07-1.47.16.1.36.31.58.62,1.54,2.14,3.08,4.29,4.61,6.43.02.02.05.03.07.01,0,0,0,0,.01-.01,1.5-2.09,3-4.18,4.51-6.28.3-.42.56-.69.77-.81.87-.48,1.99.19,1.99,1.24.01,3.63.02,7.25.02,10.88,0,.31-.03.55-.1.71-.48,1.13-2.19,1.11-2.59-.04-.06-.18-.09-.51-.09-.99,0-2.05,0-4.1,0-6.14Z" />
    <path fill="#fff" d="M57.1,36.11c1.81.04,2.95.04,3.42,0,1.48-.15,2.81-.88,3.37-2.31.43-1.1.41-2.59-.05-3.66-.71-1.68-2.35-2.28-4.13-2.28-1.26,0-2.52,0-3.77,0-.41,0-.71-.05-.9-.14-1.06-.52-.98-2.02.07-2.49.19-.09.45-.13.76-.13,1.37,0,2.74,0,4.1,0,4.23,0,7.16,2.99,7,7.18-.16,4.13-3.15,6.63-7.13,6.62-1.3,0-2.6,0-3.89,0-.35,0-.62-.04-.82-.13-.98-.43-.85-1.22-.85-2.33,0-1.78,0-3.57,0-5.36,0-.48.03-.81.1-.99.31-.83,1.33-1.09,2.07-.63.4.25.6.65.61,1.2,0,1.8,0,3.59,0,5.39,0,.03.01.05.05.05Z" />
    <rect fill="#fff" x="21.39" y="32" width="2.75" height="6.9" rx="1.32" ry="1.32" />
  </g>
);

const ModoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={32} height={20} rx={6} fill="#008b55" />
    <g transform="translate(-8.48, -5.12) scale(0.48)">{MODO_LOGO_PATHS}</g>
  </svg>
);

export default ModoIcon;
